// extracted by mini-css-extract-plugin
export default {"icon":"RoundIcon_icon__wWOeL"};